import {
  FileAddOutlined,
  FileTextOutlined,
  DollarOutlined,
  UserSwitchOutlined,
  TeamOutlined,
  DeploymentUnitOutlined,
} from '@ant-design/icons';

type QuickLinkIconMapper = {
  [key: string]: React.ReactNode;
};

export const QUICK_LINK_ICON_MAPPER: QuickLinkIconMapper = {
  // Broker
  '/application/broker/purchase': <UserSwitchOutlined />,
  '/application/broker/refinance': <FileTextOutlined />,

  // Processor
  '/application/processor/purchase': <TeamOutlined />,
  '/application/processor/refinance': <DeploymentUnitOutlined />,

  // Website OA (Online App)
  '/application/website-oa/purchase': <FileAddOutlined />,
  '/application/website-oa/refinance': <DollarOutlined />,
};
